const REDIS_SPACE_PREFIX = 'wechat:pc:auth:';

// 存储在 localStorage 中的全网动态多节点环境网关配置的键名
export const ENV_CONFIG_PC_KEY = REDIS_SPACE_PREFIX + 'env:config';

// 存储在 localStorage 中的 Token 统一键名
export const TOKEN_PC_KEY = REDIS_SPACE_PREFIX + 'jwt:token';
export const USER_ID_PC_KEY = REDIS_SPACE_PREFIX + 'user:id';
export const NICK_NAME_PC_KEY = REDIS_SPACE_PREFIX + 'nick:name';
export const MY_AVATAR_PC_KEY = REDIS_SPACE_PREFIX + 'my:avatar';
export const MY_SIGNATURE_PC_KEY = REDIS_SPACE_PREFIX + 'my:signature';
export const DEVICE_ID_PC_KEY = REDIS_SPACE_PREFIX + 'device:id';
export const NOTIFY_TONE_PC_KEY = REDIS_SPACE_PREFIX + 'notify:tone';
export const NOTIFY_TONE_OPTIONS = [
  { id: 'classic', name: '经典', file: 'msg-classic.aac' },
  { id: 'crisp', name: '清脆', file: 'msg-crisp.aac' },
  { id: 'soft', name: '轻柔', file: 'msg-soft.aac' },
  { id: 'off', name: '关闭', file: '' }
];
